import { ComboboxLegacy as Combobox } from '@hydrodigital/combobox';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import useParameter from '../../hooks/useParameter';

const SelectParameter = forwardRef(
	(
		{
			infrastructureId,
			onSelect,
			emitObject = false,
			defaultActiveFirstOption = true,
			filteredOptions = [],
		}: {
			infrastructureId: number | null;
			onSelect: Function;
			emitObject?: boolean;
			defaultActiveFirstOption?: boolean;
			filteredOptions?: any;
		},
		ref,
	) => {
		const [selectedValue, setSelectedValue] = useState<any>(null);
		const { parameters } = useParameter({
			infrastructureId,
		});

		useImperativeHandle(ref, () => ({
			setValue: (value: any) => {
				setSelectedValue(value);
			},
			cleanValue: () => {
				setSelectedValue(null);
			},
		}));

		// Set default value on first load
		useEffect(() => {
			if (parameters?.length > 0 && !selectedValue && defaultActiveFirstOption) {
				const firstAvailable = parameters.find(
					(p) => filteredOptions.findIndex((opt: any) => opt === p.id) < 0,
				);
				if (firstAvailable) {
					const defaultValue = {
						value: emitObject ? JSON.stringify(firstAvailable) : firstAvailable.id,
						label: firstAvailable.name,
					};
					setSelectedValue(defaultValue.value);
					onSelect(emitObject ? JSON.stringify(firstAvailable) : firstAvailable.id);
				}
			}
		}, [parameters, selectedValue, emitObject, filteredOptions, onSelect]);

		return (
			<Combobox
				value={selectedValue}
				size='small'
				placeholder="Select Parameter"
				onChange={(val) => {
					setSelectedValue(val);
					onSelect(emitObject ? JSON.parse(val || '{}') : val);
				}}
				options={(parameters || [])
					.filter((p) => {
						return (
							filteredOptions.findIndex((opt: any) => {
								return opt === p.id;
							}) < 0
						);
					})
					.map((p) => ({
						value: emitObject ? JSON.stringify(p) : p.id.toString(),
						label: p.name,
					}))}
			/>
		);
	},
);

export default SelectParameter;
